export const ENV = {
  baseUrl: process.env.REACT_APP_BASE_URL,
};
